import moment from 'moment';
import {translator} from "../components/helpers";

export function initAvailableTicketsLanding() {
    let ajaxUrl = '/ajax/getAvailableTickets';

    //для теста второго теста (50% скидки)
    if (window.location.href.includes('biletnaya-sistema-x2')) {
        ajaxUrl = '/ajax/getavailableticketsv2';
    }

    const mockData = {
        "3253": {
            "club1": {
                "id": "26",
                "name": "\u041a\u0440\u044b\u043b\u044c\u044f C\u043e\u0432\u0435\u0442\u043e\u0432",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club26.svg"
            },
            "club2": {
                "id": "5",
                "name": "\u041b\u043e\u043a\u043e\u043c\u043e\u0442\u0438\u0432 ",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club5.svg"
            },
            "matchDate": "2023-05-14 15:00:00",
            "stadium": {
                "name": "\u0421\u0430\u043c\u0430\u0440\u0430, \u0421\u043e\u043b\u0438\u0434\u0430\u0440\u043d\u043e\u0441\u0442\u044c \u0421\u0430\u043c\u0430\u0440\u0430 \u0410\u0440\u0435\u043d\u0430",
                "link": "\/stadium\/"
            },
            "tournament": {
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/t28.svg",
                "roundNumber": "27",
                "name": "\u041c\u0418\u0420 \u0420\u041f\u041b",
                "id": "28"
            },
            "salesStatus": 1,
            "saleStartDate": "2023-05-02 16:32:00",
            "startPrice": 250,
            "link": "?matchId=3253",
            "discountInfo": "",
            "countBuyTickets": 0
        },
        "3251": {
            "club1": {
                "id": "26",
                "name": "\u041a\u0440\u044b\u043b\u044c\u044f C\u043e\u0432\u0435\u0442\u043e\u0432",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club26.svg"
            },
            "club2": {
                "id": "12",
                "name": "\u0423\u0440\u0430\u043b",
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/club12.svg"
            },
            "matchDate": "2023-05-21 15:00:00",
            "stadium": {
                "name": "\u0421\u0430\u043c\u0430\u0440\u0430, \u0421\u043e\u043b\u0438\u0434\u0430\u0440\u043d\u043e\u0441\u0442\u044c \u0421\u0430\u043c\u0430\u0440\u0430 \u0410\u0440\u0435\u043d\u0430",
                "link": "\/stadium\/"
            },
            "tournament": {
                "logo": "https:\/\/ksstatistics.internetlab.ru\/upload\/t28.svg",
                "roundNumber": "28",
                "name": "\u041c\u0418\u0420 \u0420\u041f\u041b",
                "id": "28"
            },
            "salesStatus": 1,
            "saleStartDate": "2023-05-02 16:32:00",
            "startPrice": 150,
            "link": "?matchId=3251",
            "discountInfo": "",
            "countBuyTickets": 0
        }
    }
    const preloader = $('#page_preloader');
    const matchesContainer = $('#available_matches_container');
    const matchesHolder = $('#available_matches');
    const abonementsHolder = $('#available_abonements');
    const $abonementsSection = $('[data-abonements-block]');
    let isLoading = false;
    let shouldNotLoad = false;
    let lang = 'ru';
    const isProd = true;

    //если есть подкаталог /en/ -> англ язык
    if (window.location.pathname.includes('/en/')) {
        lang = 'en';

    } else {
        lang = 'ru';
    }
    renderLanguageHandler();
    getTicketData();

    function showLoading() {
        matchesContainer.addClass('hide');
        preloader.removeClass('hide');
    }

    function hideLoading() {
        matchesContainer.removeClass('hide');
        preloader.addClass('hide');
    }

    // рендрим список матчей доступных для продажи билетов
    function renderMatchesTicketsList(data) {
        matchesHolder.removeClass('error');
        $('.change-lang-block').removeClass('error');

        let abonementsBlock = '';
        let matchBlock = '';

        matchesHolder.html('');
        abonementsHolder.html('');

        $.each(data, function (index, item) {
            //если отсутствуют обязательные данные - пропускаем
            if (item?.type === "subscription") {

                if (+item?.countBuyTickets === 4) {
                    abonementsBlock += `
                        <div class="match">
                            <div class="h4">${translator('Уважаемый болельщик', lang)}!</div>
                            <p class="no-margin-top">
                                ${translator('Допустима продажа до 4-х сезонных билетов на одну учетную регистрационную запись', lang)}.
                            </p>
                        </div>`;

                } else if (item?.logo && item?.year) {
                    abonementsBlock += renderAbonementsTickets(item);
                }

            } else {
                if (+item?.countBuyTickets === 20) {
                    matchBlock += `
                        <div class="match">
                            <div class="h4">${translator('Уважаемый болельщик', lang)}!</div>
                             <p class="no-margin-top">
                                ${translator('Допустима продажа до 20 билетов на одну учетную регистрационную запись', lang)}.
                            </p>
                        </div>`;

                } else {
                    matchBlock += renderMatchesTicketsBlock(item);
                }
            }
        });

        //скрытие абонементов, если их нет
        if (!abonementsBlock) {
            $abonementsSection.hide();

        } else {
            abonementsHolder.append(abonementsBlock);
        }

        //если есть билеты - вставляем верстку в темлейт
        if (matchBlock) {
            matchesHolder.append(matchBlock);

        } else {
            matchesHolder.siblings('.h3.color-white').hide();
        }

        //если оба блока пустые - выводим сообщение
        if (!matchBlock && !abonementsBlock) {
            showNoTicketsMessage();
        }

        hideLoading();
    }

    // рендрим блок с информацией о матче
    function renderMatchesTicketsBlock(item) {
        const ticketsInfo = renderTicketsInfo(item);
        const ticketLinkDisabled = setButtonDisable(item);
        const [matchDate, daysBeforeMatch] = calculateMatchDate(item);
        const isDiscountPurchase = item?.discountInfo;

        let discountPurchaseHTML = '';
        let discountMatchClass = '';

        //50% скидки
        if (isDiscountPurchase) {
            discountPurchaseHTML = `<div class="discount-purchase">${translator('При покупке билета на этот матч, вы получите скидку 50% на матч', lang)} ${isDiscountPurchase}</div>`;
            discountMatchClass = 'discount';
        }

        if (!matchDate) return; //прерываем, если матч прошел

        return `
            ${discountPurchaseHTML}
            <div class="match ${discountMatchClass}">
                <div class="flex-grid tablet-column">
                    <div class="col w-35-desktop">
                        <div class="clubs">
                            <img class="logo owner" src="${item?.club1?.logo ? item.club1.logo : ''}" alt="${item?.club1?.name ? item.club1.name : ''}">
                            <img class="logo guest" src="${item?.club2?.logo ? item.club2.logo : ''}" alt="${item?.club2?.name ? item.club2.name : ''}">
                            <div class="names">
                                <div class="owner">${item?.club1?.name ? item.club1.name : ''}</div>
                                <div class="guest">${item?.club2?.name ? item.club2.name : ''}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col w-35-desktop flex-grow">
                        <div class="info">
                            <div class="date">${matchDate} ${daysBeforeMatch}</div>
                            <div class="tournament">
                                ${item?.tournament?.name ? item.tournament.name : ''},
                                <span class="tournament-round">${item?.tournament?.roundNumber ? item?.tournament?.roundNumber : ''} ${translator('тур', lang)}</span>
                            </div>
                            <a class="stadium" href="${item?.stadium?.link ? item.stadium.link : ''}">${item?.stadium?.name ? item.stadium.name : ''}</a>
                        </div>
                    </div>

                    <div class="col w-20-desktop">
                        <a href="${ticketLinkDisabled ? ticketLinkDisabled : item.link}"
                           class="button theme-secondary large no-text-transform ${ticketLinkDisabled} buy-tickets-link"
                        >
                            ${ticketsInfo}
                        </a>
                    </div>
                </div>
            </div>
        `;
    }

    // рендрим блок с информацией об абонементе
    function renderAbonementsTickets(item) {
        const ticketsInfo = renderAbonementInfo(item);
        const ticketLinkDisabled = setButtonDisable(item);
        let earlyAccessBlock = '';

        // Задача 40116 2. Вот эту надпись надо убрать http://joxi.ru/gmvX6NPCePWJ8A
        // if(item?.earlyAccess){
        //     earlyAccessBlock = ` <p class="early-access">Приоритетная продажа для покупателей абонементов сезона 21/22</p>`
        // }

        return `
            <div class="match">
                <div class="flex-grid tablet-column">
                    <div class="col w-35-desktop">
                        <div class="clubs">
                            <img class="logo owner" src="${item?.logo ? item.logo : ''}" alt="${item?.name ? item.name : ''}">
                            <div class="names">
                                <div class="owner">${item?.name ? item.name : ''}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col w-35-desktop flex-grow">
                        <div class="info">
                            <div class="date">${translator('Сезон', lang)} ${item?.year}</div>
                            ${earlyAccessBlock}
                            <a class="stadium" href="${item?.stadium.link ? item.stadium.link : ''}">${item?.stadium.name ? item.stadium.name : ''}</a>
                        </div>
                    </div>

                    <div class="col w-20-desktop">
                        <a href="${ticketLinkDisabled ? ticketLinkDisabled : item?.link}"
                           class="button theme-secondary large no-text-transform ${ticketLinkDisabled} buy-tickets-link"
                        >
                            ${ticketsInfo}
                        </a>
                    </div>
                </div>
            </div>
        `;
    }

    // формируем дату в строковом формате понятном пользователю
    function calculateMatchDate(item) {
        // Первичная проверка, если дата неизвестна или пуста.
        if (['', null, undefined].includes(item.matchDate)) return [`${translator('Дата будет известна позднее', lang)}`, ''];

        const maxDaysShownBeforeMatch = 6;
        let now, tomorrow, matchDate;

        if (lang === 'en') {
            now = moment().locale('en');
            tomorrow = moment(new Date()).add(1, 'days').locale('en');
            matchDate = moment(item.matchDate).locale('en');

        } else {
            now = moment().locale('ru');
            tomorrow = moment(new Date()).add(1, 'days').locale('ru');
            matchDate = moment(item.matchDate).locale('ru');
        }

        const daysBeforeMatch = matchDate.diff(now, 'days');
        let returnedDate = matchDate.format('DD MMM, HH:mm').replace('.', '');
        let returnedDaysBeforeMatch = '';

        // если мач прошел. Ну мало ли? косяк на беке...
        if (matchDate.diff(now, 'second') <= -1) {
            returnedDate = false;
            returnedDaysBeforeMatch = matchDate.fromNow();
        }

        // если дней до матча больше одного
        if (daysBeforeMatch > 0 && daysBeforeMatch <= maxDaysShownBeforeMatch) {
            returnedDaysBeforeMatch = `<span class="nobr">(${matchDate.fromNow()})</span>`;
        }

        // если матч завтра
        if (matchDate.format('DD MMM YYYY') === tomorrow.format('DD MMM YYYY')) {

            if (lang === 'en') {
                returnedDate = 'Tomorrow at ' + matchDate.format('HH:mm');

            } else {
                returnedDate = matchDate.format('Завтра в HH:mm');
            }
            returnedDaysBeforeMatch = '';
        }

        // если матч сегодня
        if (matchDate.format('DD MMM YYYY') === now.format('DD MMM YYYY')) {
            if (lang === 'en') {
                returnedDate = 'Today at ' + matchDate.format('HH:mm');

            } else {
                returnedDate = matchDate.format('Сегодня в HH:mm');
            }

            returnedDaysBeforeMatch = '';
        }

        return [
            returnedDate,
            returnedDaysBeforeMatch
        ];
    }

    // определяем контент кнопки-ссылки в зависимости от статуса продаж
    function renderTicketsInfo(item) {
        if (+item.salesStatus === 1 && item.startPrice) return `${translator('Купить', lang)}`;
        if (+item.salesStatus === 2 && item.saleStartDate) {
            const date = moment(item.saleStartDate).locale('ru').format('DD.MM');
            return `${translator('В продаже с', lang)} ${date}`;
        }

        return `${translator('Билетов нет', lang)}`;
    }

    // определяем контент кнопки-ссылки в зависимости от статуса продаж (абонемент)
    function renderAbonementInfo(item) {
        if (+item.salesStatus === 1 && item.startPrice) return `${translator('Купить', lang)}`;
        if (+item.salesStatus === 2 && item.saleStartDate) {
            const date = moment(item.saleStartDate).locale('ru').format('DD.MM');
            return `${translator('В продаже с', lang)} ${date}`;
        }

        return `${translator('Абонементов нет', lang)}`;
    }

    // устанавливаем доступность кнопки в зависимости от статуса продаж
    function setButtonDisable(item) {
        if (+item.salesStatus !== 1) return 'disabled';
        if (!item.link) return 'disabled';

        return '';
    }

    // получаем данные о матчах доступных для продажи билетов
    function getTicketData() {
        if (isLoading || shouldNotLoad) return;
        isLoading = true;
        showLoading();

        $.ajax({
            url: ajaxUrl + `?lang=${lang}`,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            success: (res) => {
                if (!res && !res.length) {
                    showNoTicketsMessage();
                } else {
                    res = sortMatchesData(res, 'matchDate');
                    renderMatchesTicketsList(res);
                }

                isLoading = false;
            },
            error: (res) => {

                if (!isProd) {
                    res = mockData;
                    if (!res && !res.length) {
                        showNoTicketsMessage();

                    } else {
                        res = sortMatchesData(res, 'matchDate');
                        renderMatchesTicketsList(res);
                    }
                } else {
                    $abonementsSection.hide();
                    matchesHolder.siblings('.h3.color-white').hide();
                    showErrorMessage();
                }
                isLoading = false;
            },
        });
    }

    // Выводим сообщение, если билетов нет (пришел пустой массив)
    function showNoTicketsMessage() {
        matchesHolder.siblings('.h3.color-white').hide();
        const messageTemplate = `
            <div class="no-events">
              <span>${translator('Уважаемые болельщики', lang)}!</span>
              <span class="small-text">${translator('Совсем скоро вы вновь сможете приобрести сезонные абонементы на матчи «Крыльев Советов». Пока у вас есть возможность оформить карту болельщика, которая будет необходима для покупки билетов и абонементов и посещения стадиона.', lang)}</span>
              <span class="small-text">${translator('Карту болельщика можно оформить на сайте', lang)} <a target="_blank" href="https://www.gosuslugi.ru/fancard" class="small-text">${translator('Госуслуг', lang)}</a></span> 
            </div>
        `;
        matchesContainer.append(messageTemplate);
        hideLoading();
    }

    // Выводим сообщение, если произошла ошибка при запросе
    function showErrorMessage() {
        const messageTemplate = `
            <div class="match error">
                <div class="h4">${translator('Что-то пошло не так', lang)}</div>
                <div class="button theme-secondary" id="get_tickets_data_again">${translator('Попробовать снова', lang)}</div>
            </div>
        `;
        matchesHolder.html(messageTemplate);
        hideLoading();

        matchesHolder.addClass('error');
        $('.change-lang-block').addClass('error');

        $('#get_tickets_data_again').click((e) => {
            e.preventDefault();
            getTicketData();
        })
    }

    function renderLanguageHandler() {
        let langLink = '';
        let langText = '';

        if (lang === 'en') {
            langLink = 'https://pfcks.ru/tickets/';
            langText = 'RU';

        } else if (lang === 'ru') {
            langLink = 'https://pfcks.ru/en/tickets/';
            langText = 'EN';
        }

        const languageHandlerHTML = `
        <div class="change-lang-block">
            <a href="${langLink}">${langText}</a>
        </div>`;


        matchesContainer.append(languageHandlerHTML);

        translateStaticText();
    }

    function translateStaticText() {
        $('[data-tickets-title]').text(`${translator('Билеты', lang)}`);
        $('[data-abonements-title]').text(`${translator('СЕЗОННЫЙ БИЛЕТ', lang)}`);
        $('[data-pay-systems-text-1]').text(`${translator('В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa или MasterCard Secure Code, для проведения платежа также может потребоваться ввод специального пароля. Способы и возможность получения паролей для совершения интернет-платежей Вы можете уточнить в банке, выпустившем карту.', lang)}`);
        $('[data-pay-systems-text-2]').text(`${translator('Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО «Сбербанк России». Введенная информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платежных систем Visa Int. и MasterCard Europe Sprl.', lang)}`);
    }

    function sortMatchesData(data, attr) {
        var arr = [];
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                var obj = {};
                obj[prop] = data[prop];
                obj.tempSortName = data[prop][attr].toLowerCase();
                arr.push(obj);
            }
        }

        arr.sort(function(a, b) {
            var at = a.tempSortName,
                bt = b.tempSortName;
            return at > bt ? 1 : ( at < bt ? -1 : 0 );
        });

        var result = [];
        for (var i=0, l=arr.length; i<l; i++) {
            var obj = arr[i];
            delete obj.tempSortName;
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    var id = prop;
                }
            }
            var item = obj[id];
            result.push(item);
        }
        return result;
    }
}
